import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import tw from './i18n/tw';
import ch from './i18n/ch';

i18next.addResourceBundle('en', 'minerals', en);
i18next.addResourceBundle('tw', 'minerals', tw);
i18next.addResourceBundle('ch', 'minerals', ch);

const MineralsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/responsible-minerals',
			component: React.lazy(() => import('./Minerals'))
		}
	]
};

export default MineralsConfig;
